import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';
import { SCORE_SIZE } from '../Score';
import { getCircleSize } from '../Score/utils';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',

      '&$vertical': {
        flexFlow: 'column nowrap',
        height: getCircleSize(SCORE_SIZE.large),
      },
      '&$small': {
        '& $buttonGetScore': {
          minWidth: 'auto',
        },
        '& $iconDiamond': {
          marginRight: theme.spacing(-0.5),
        },
      },
    },
    vertical: {},
    small: {},

    buttonGetScore: {
      minWidth: 91,
      height: 28,
      padding: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.2,
    },
    iconDiamond: {
      // HINT: we need to overcome specificity of ".MuiButton-iconSizeMedium > *:first-child"
      '&&': {
        fontSize: theme.typography.pxToRem(20),
      },
    },
    buttonUndo: {
      minWidth: 'auto',
      marginLeft: theme.spacing(0.5),
      padding: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(10),
      lineHeight: 1.2,
      color: COLORS.neutral.mediumGray,
      textDecoration: 'none',

      '&:focus:enabled': {
        color: COLORS.neutral.mediumGray,
      },
      '&:hover:enabled': {
        color: COLORS.primary.default,
      },
      '&[disabled]': {
        color: theme.palette.action.disabled,
      },
      '$vertical &': {
        marginLeft: 0,
        marginTop: theme.spacing(0.5),
      },
    },
  }),
  { name: 'LockedScoreButtons' }
);
